import { useMemo } from "react";
import { useSelector } from "react-redux";
import { CarsShopSelector } from "../../../store";
import type { ShopPageContainerProps } from "../types";

export const useShopPageContainer = ({
  goToNextStep,
  car,
  dayCount,
}: ShopPageContainerProps) => {
  const {
    data: { data: shop },
    isLoading,
    isError,
  } = useSelector(CarsShopSelector.getCarShop);

  return useMemo(
    () => ({
      context: {
        data: shop,
        isLoading,
        isError,
        car,
        dayCount,
      },
      handlers: {
        goToNextStep: !isLoading && !isError ? goToNextStep : undefined,
      },
    }),
    [car, dayCount, goToNextStep, isError, isLoading, shop]
  );
};
